import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/lib/stores/authStore';

/**
 * Bloqueia as rotas internas para quem não está autenticado.
 * A origem é guardada em `state.from` para devolver o usuário ao destino
 * pretendido depois do login.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const token = useAuthStore((s) => s.token);
  const location = useLocation();

  if (!isAuthenticated || !token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
